import React, { FC } from "react";

// i18n
import messages from "./messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

// UI
import { Box } from "@UI/Components/Box/Box";

// hooks
import { useDataMutation } from "@Libs/DataLayer/hooks/useDataMutation";
import { IOutlets } from "@Transclusion/types/outlets";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { PaymentMethodForm } from "@modules/PaymentProcessing/Components/PaymentMethodForm/PaymentMethodForm";
import { ResponsiveFixedButton } from "@UI/Components/ResponsiveFixedButton/ResponsiveFixedButton";

type Props = Omit<
  IOutlets["configure-preferred-payment-method.body"]["props"],
  "paymentMethod" | "basket"
> & { children?: React.ReactNode };

export const ConfigureBankTransfer: FC<Props> = ({ onBack, onSubmit, children }) => {
  const saveBankTransferMethodMutation = useDataMutation(() =>
    onSubmit({
      provider: "company_operations",
      paymentMethod: PaymentMethodType.BANK_TRANSFER,
    })
  );

  return (
    <PaymentMethodForm>
      <PaymentMethodForm.Header
        onChangeClick={onBack}
        paymentMethod={PaymentMethodType.BANK_TRANSFER}
      >
        <FormattedMessage {...messages.bankTransfer} />
      </PaymentMethodForm.Header>

      <PaymentMethodForm.Body>
        <Box>
          <Box mb={5}>{children}</Box>
          <ResponsiveFixedButton
            data-testid="submit-bank-transfer-button"
            isLoading={saveBankTransferMethodMutation.isLoading}
            h={12}
            width="full"
            colorScheme="seaGreen"
            onClick={() => saveBankTransferMethodMutation.mutate()}
            isDisabled={saveBankTransferMethodMutation.isLoading}
          >
            <FormattedMessage {...messages.submit} />
          </ResponsiveFixedButton>
        </Box>
      </PaymentMethodForm.Body>
    </PaymentMethodForm>
  );
};
